import axios from 'axios';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { cdnUrl, url } from './constant.tsx';
import {
  enSharedTranslation,
  heSharedTranslation,
  i18nSharedConfig,
} from '@bepro-travel/fe.shared';
import { i18nConfig } from '@bepro-travel/fe.ui';
import { enTr } from './locales/en.tsx';
import { heTr } from './locales/he.tsx';

export const configureAxios = () => {
  axios.defaults.baseURL = url;
  axios.defaults.headers.common['Content-Type'] = 'application/json';
  axios.defaults.headers.common.Accept = 'application/json';
};
export const i18nconfig = () => {
  const lang = localStorage.getItem('language');

  const enTranslation = {
    ...enSharedTranslation,
    ...enTr,
  };
  const heTranslation = {
    ...heSharedTranslation,
    ...heTr,
  };

  i18n.use(initReactI18next).init({
    resources: {
      ru: {
        translation: {},
      },
      en: {
        translation: enTranslation,
      },
      he: {
        translation: heTranslation,
      },
    },
    lng: lang ? lang : 'he',
    fallbackLng: 'he',

    interpolation: {
      escapeValue: false,
    },
  });
  i18nSharedConfig({ enTranslation, heTranslation, ruTranslation: {} });
  i18nConfig({ enTranslation, heTranslation });
};

export const getPacImg = (dest: any, main: boolean) => {
  const img = dest?.listOfGalleryId.find((img) => img.main === main);
  if (img) {
    return cdnUrl + '/backend' + img.code;
  }
};
